import api from "./api";
import StorageService from "./StorageService";

const ProjectItemService = {
  // ✅ Get all project items
  getAll: (companyId, page = 1, limit = 20, employeeId = null, roleId = null, search = "", projectId = "",itemSearch = "",
    categoryId = "") => {
    const login = StorageService.loginData();
    return api.get(`/projectItems/getAll?companyId=${companyId}`, {
      params: {
        page,
        limit,
        employeeId: employeeId || login?.employeeId,
        roleId: roleId || login?.roleId,
        search: search || undefined,
        projectId: projectId || undefined,
          itemSearch: itemSearch || undefined,
           categoryId: categoryId || undefined,
      },
    });
  },



  // ✅ Get project item by ID
  getById: (id) => {
    return api.get(`/projectItems/getById/${id}`);
  },

  // ✅ Get project items by projectId
  getByProjectId: (projectId) => {
    return api.get(`/projectItems/getByProjectId/${projectId}`);
  },

  // ✅ Create project item
  create: (data) => {
    return api.post("/projectItems/save", data);
  },

  // ✅ Update project item
  update: (id, data) => {
    return api.put(`/projectItems/update/${id}`, data);
  },

  // ✅ Toggle Active / Inactive status
  toggleStatus: (id) => {
    return api.put(`/projectItems/updatestatus/${id}`);
  },

  // ✅ NEW → get categories + items by project
  getProjectFullData: (projectId) => {
    return api.get(`/projectItems/getProjectFullData/${projectId}`);
  },



};

export default ProjectItemService;
